import React from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";

/** Layouts */
// import ErrorLayout from "./Views/ErrorView/route";
import CommonLayout from "./Views/CommonView/route";
import HomeLayout from "./Views/HomeView/route";

/** Pages */
import Home from "./Pages/Home";
import Systemy from "./Pages/RSISYSTEMY";
import SystemyInfo from "./Pages/RSISYSTEMY/infopage";
import Gestorzy from "./Pages/RSIGESTORZY";
import GestorzyInfo from "./Pages/RSIGESTORZY/infopage";
import Obiekty from "./Pages/RSIOBIEKTY";
import Cechy from "./Pages/RSICECHY";
import CechyInfo from "./Pages/RSICECHY/infopage";
import Deklaracja from "./Pages/Deklaracja";
import Polityka from "./Pages/Polityka";
import Error404 from "./Pages/Errors/404";
import Error403 from "./Pages/Errors/403";
import SiteMap from "./Pages/SiteMap";
import Pomoc from "./Pages/POMOC";

export default function Routes() {
    const { i18n } = useTranslation();
    // console.log("Routes", { language: i18n.language, i18n });

    const pathLang = window.location.pathname?.split("/")?.filter((f) => f);
    const _defaultLng = i18n.options.defaultLng;

    let _hasLangInPath = pathLang?.filter((l) => i18n.options.supportedLngs?.includes(l))?.[0];

    // console.log({ pathLang });
    // console.log({ _hasLangInPath });

    if (!_hasLangInPath && i18n.language !== _defaultLng) {
        setTimeout(() => {
            i18n.changeLanguage(_defaultLng);
        }, 500);
    }

    return (
        <Router basename={`/${i18n.language}`}>
            <Switch>
                <HomeLayout exact path="/" component={Home} />

                <CommonLayout
                    exact
                    path="/rsisystemy"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : Systemy}
                />
                <CommonLayout
                    path="/rsisystemy/:id"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : SystemyInfo}
                    noBanner={true}
                />

                <CommonLayout
                    exact
                    path="/rsigestorzy"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : Gestorzy}
                />
                {/* <CommonLayout
                    exact
                    path="/rsigestorzy/:id"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : Gestorzy}
                /> */}

                <CommonLayout
                    path="/rsigestorzy/info/:id"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : GestorzyInfo}
                />

                <CommonLayout
                    exact
                    path="/rsiobiekty"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : Obiekty}
                />
                <CommonLayout
                    path="/rsiobiekty/:typ_obiektu__icontains"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : Obiekty}
                />

                <CommonLayout
                    exact
                    path="/rsicechy"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : Cechy}
                />
                <CommonLayout
                    path="/rsicechy/:id"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : CechyInfo}
                />

                <CommonLayout exact path="/deklaracja" component={Deklaracja} />

                <CommonLayout exact path="/polityka-prywatnosci" component={Polityka} />

                <CommonLayout exact path="/sitemap" component={SiteMap} noBanner={true} />

                <CommonLayout
                    exact
                    path="/pomoc"
                    component={i18n.language !== "pl" ? () => <Redirect to="/404" /> : Pomoc}
                />

                <CommonLayout exact path="/404" component={Error404} noBanner={true} />

                <CommonLayout exact path="/denied" component={Error403} noBanner={true} />

                <CommonLayout path="/*" component={() => <Redirect to="/404" />} noBanner={true} />
            </Switch>
        </Router>
    );
}
